import api from "./axios";

const BASE = "/admin-users";

export const listAdminUsers = async (params = {}) => {
  const response = await api.get(BASE, { params });
  return response.data;
};

export const getAdminUser = async (id) => {
  const response = await api.get(`${BASE}/${id}`);
  return response.data;
};

export const createAdminUser = async (data) => {
  // Longer timeout: request waits for the welcome email to be sent
  const response = await api.post(BASE, data, { timeout: 45000 });
  return response.data;
};

export const updateAdminUserProfile = async (id, data) => {
  const response = await api.put(`${BASE}/${id}`, data);
  return response.data;
};

export const updateZoneMapping = async (id, zoneMapping) => {
  const response = await api.put(`${BASE}/${id}/zone-mapping`, { zoneMapping });
  return response.data;
};

export const updateAccessControl = async (id, permissions) => {
  const response = await api.put(`${BASE}/${id}/access-control`, { permissions });
  return response.data;
};

export const updateSecurity = async (id, data) => {
  const response = await api.put(`${BASE}/${id}/security`, data);
  return response.data;
};

export const forceResetPassword = async (userId, newPassword) => {
  const payload = newPassword ? { newPassword } : {};
  // Longer timeout: request waits for the reset email to be sent
  const response = await api.post(`/auth/force-reset/${userId}`, payload, { timeout: 45000 });
  return response.data;
};

export const deleteAdminUser = async (id) => {
  const response = await api.delete(`${BASE}/${id}`);
  return response.data;
};
